import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProfileSite } from '@ffd/api-client';
import { Person } from '@libs/ui-lib';
import { TranslateModule } from '@ngx-translate/core';
import { ffdNotesRoutePrefix, routes } from '@libs/utils';
import { FfdNotesHeaderProfileComponent } from '../ffd-notes-header-profile';

@Component({
  selector: 'lib-ffd-notes-header',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule, FfdNotesHeaderProfileComponent],
  templateUrl: './ffd-notes-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNotesHeaderComponent {
  @Input({ required: true }) public loggedInUser: Person | null = null;
  @Input({ required: true }) public selectedSite: ProfileSite | null = null;
  @Input({ required: true }) public sitesCount: number | null = null;

  @Output() public logout = new EventEmitter<void>();
  @Output() public support = new EventEmitter<void>();

  protected routes = routes;
  protected homeRoute = ffdNotesRoutePrefix();

  public onLogout(): void {
    this.logout.emit();
  }

  public onSupport(): void {
    this.support.emit();
  }
}
